
/**
 * route - the rect router dom route
 * mainMenu - MOBILE => if its on the nav bar
 * loggedIn - if the user needs to be logged in to see this route
 * iconOnly - if it only shows the route
 * adminOnly - admin only route
 */
export default [
    {
        route: "/",
        name: "home",
        icon: "fas fa-home",
        mainMenu:true,
        loggedIn:false,
        iconOnly:false,
    },
    {
        route: "/anomalies",
        name: "anomalies",
        icon: "fas fa-exclamation-circle",
        mainMenu:true,
        loggedIn:false,
    },
    {
        route: "/admin",
        name: "admin",
        icon: "fas fa-user-shield",
        mainMenu: true,
        loggedIn: true,
        adminOnly: true,
        iconOnly: false,
    },
]